export const config = {
  BaseURL: process.env.REACT_APP_API_BASE_URL,
  GoogleClientID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  expiredMin:process.env.REACT_APP_EXPIRED_TOKEN_MINUTE
};
